// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { ApiUsersRepoService } from '@client/app/services/api/api-users-repo.service';
import { ApiUsersService } from '@client/app/pages/admin/api-users/services/api-users.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

@Component({
    selector: 'form-api-users',
    templateUrl: './api-users-form.component.html',
    standalone: false,
})
export class ApiUsersFormComponent implements OnInit {
    @Input() apiUser: any;
    @Input() monDialogId: string = '';

    saving: boolean = false;
    ngModel: any = {};
    scopes: any[] = [];

    constructor (
        private monDialog: MonDialog,
        private apiUsersRepo: ApiUsersRepoService,
        private apiUsersService: ApiUsersService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.saving = false;
        this.ngModel = this.apiUser || {};
        this.ngModel.scopes = this.ngModel.scopes || [];
        this.scopes = this.apiUsersService.getScopes();
    }

    setScope (scopeValue: any) {
        if (this.isScopeChecked(scopeValue)) {
            const index = this.ngModel.scopes.indexOf(scopeValue);
            this.ngModel.scopes.splice(index, 1);
        } else {
            this.ngModel.scopes.push(scopeValue);
        }
    }

    isScopeChecked (scopeValue: any): boolean {
        return this.ngModel.scopes.indexOf(scopeValue) > -1;
    }

    submit () {
        this.saving = true;

        this.apiUsersRepo.create(this.ngModel).then(
            (apiUser: any) => {
                this.close(apiUser);
            },
            () => {
                this.saving = false;
            },
        );
    }

    close (apiUser: any) {
        this.monDialog.close(this.monDialogId, apiUser);
    }

    trackByIndex (index: number): number {
        return index;
    }
}
